import { ScrollView, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useJourney } from '../contexts/JourneyContext';
import ContentItemsList from '../elements/ContentItemsList';
import styles from '../Styles';

export default function ScreenCaptions(props) {
  const journey = useJourney();
  const location = props.location || journey.selectedLocation;

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <View style={styles.screenHeadingWithBackground}>
        <Text style={styles.headingText}>{location.name}</Text>
      </View>

      <ScrollView style={{flex: 1}} contentContainerStyle={{flexGrow: 1}}>            
        <ContentItemsList 
          contentItems={location.captions} 
          coverImage={location.icon}
          completionButtonTapped={props.onComplete} 
          completionButtonLabel="Finished"   
          dontShowFinishedButton={journey.appPhase === "Finale"}
        />
      </ScrollView>
    </SafeAreaView>
  );
}